const { withRouter } = require("react-router-dom");
const PromoCodeForm = require("../../admin-promocodes/components/PromoCodeForm");
const React = require("react");
const T = require("prop-types");
const NavLink = require("react-router-dom").NavLink;

class PromoCodes extends React.Component {
    static propTypes = {
        isSaving: T.bool.isRequired,

        addPromoCode: T.func.isRequired
    };

    render() {
        return (
            <div>
                <NavLink to="/admin/promocodes">← Back to promo codes</NavLink>
                <h2>Add Promo Code</h2>

                <PromoCodeForm
                    isSaving={this.props.isSaving}
                    save={this.props.addPromoCode}
                />
            </div>
        );
    }
}

module.exports = withRouter(PromoCodes);



// WEBPACK FOOTER //
// ./src/routes/admin-promocodes-add/components/PromoCodes.js